import { useEffect } from 'react';
import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { BuyConfirmResponseData } from './store/buyConfirmStore';

// false commit
export const buyConfirm = ({
  product,
  id,
}: {
  product: string;
  id: string;
}) => {
  return axios<
    BuyConfirmResponseData,
    BaseResponse<BuyConfirmResponseData>,
    void
  >({
    url: `/products/${product}/transactions/${id}`,
    method: 'get',
    params: {
      flowType: 'one_time',
    },
  });
};

export const useBuyStatus = ({
  product,
  id,
}: {
  product: string;
  id: string;
}) => {
  const { data, isLoading, isSuccess, error } = useQuery({
    queryKey: [
      'buyconfirm',
      {
        product,
        id,
      },
    ],
    queryFn: () => buyConfirm({ product, id }),
    enabled: !!id,
    useErrorBoundary: false,
  });

  useEffect(() => {
    displayError(error);
  }, [error]);

  return {
    data,
    isLoading,
    isSuccess,
  };
};
